export class IngestionPartitionStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<IngestionPartitionStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<IngestionPartitionStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPartitionStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
